/*
  Keyboard and screen reader behavior for the desktop mega menus. The panels still open on hover through CSS;
  this adds the trigger button (.header__submenu-toggle) state:
  - Enter or Space on the button toggles its panel (aria-expanded, and .is-open on the list item).
  - Escape inside an open panel (or on the button) closes it and returns focus to the button.
  - Focus moving out of the list item (tabbing past the last link of the panel) closes it.
*/
(function () {
  var nav = document.querySelector('.header__inline-menu');
  if (!nav) return;

  function items() {
    return nav.querySelectorAll('li.mega-menu');
  }

  function setOpen(item, open) {
    var button = item.querySelector(':scope > .header__submenu-toggle');
    item.classList.toggle('is-open', open);
    if (button) button.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function closeAll(except) {
    items().forEach(function (item) {
      if (item !== except) setOpen(item, false);
    });
  }

  nav.addEventListener('click', function (event) {
    var button = event.target.closest('.header__submenu-toggle');
    if (!button || !nav.contains(button)) return;
    var item = button.closest('li.mega-menu');
    var open = !item.classList.contains('is-open');
    closeAll(item);
    setOpen(item, open);
  });

  nav.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var item = event.target.closest('li.mega-menu');
    if (!item || !item.classList.contains('is-open')) return;
    setOpen(item, false);
    var button = item.querySelector(':scope > .header__submenu-toggle');
    if (button) button.focus();
    event.stopPropagation();
  });

  nav.addEventListener('focusout', function (event) {
    var item = event.target.closest('li.mega-menu');
    if (!item || !item.classList.contains('is-open')) return;
    if (event.relatedTarget && item.contains(event.relatedTarget)) return;
    setOpen(item, false);
  });
})();
